import { ColumnsWitdhType } from '../../../../types/types';

export const getSumOfColumnWidths = (columnsWidth: ColumnsWitdhType) => {
  if (!columnsWidth) {
    return 0;
  }
  return Object.values(columnsWidth).reduce((a, b) => a + b, 0);
};
